import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AppbarWithSidebar } from "../components/layout";
import { sidebar } from "../constants/sidebar";
import AccessDeniedPage from "../pages/dashboard/access-denied-page";
import useSidebarStore from "../zustand/stores/sidebar-store";

export function ProtectedRoute({ element }) {
  const location = useLocation();
  const isAuthenticated = localStorage.getItem("token");
  const accessPermission = localStorage.getItem("permission");

  const localAccessedSidebar = useSidebarStore(
    (state) => state.localAccessedSidebar,
  );
  const setLocalAccessedSidebar = useSidebarStore(
    (state) => state.setLocalAccessedSidebar,
  );

  // Process sidebar access only once when dependencies change
  useEffect(() => {
    let accesedSidebar = [];

    if (accessPermission) {
      const accesPermissionParsed = JSON.parse(accessPermission);
      console.log({ PARSED: accesPermissionParsed });
      accesedSidebar = sidebar
        .map((element) => {
          const processContent = (items) =>
            items
              .map((item) => {
                // Skip manage-operator-account
                if (item.tag === "manage-operator-account") {
                  return null;
                }

                const isAccessible =
                  item.tag &&
                  (Array.isArray(item.tag)
                    ? item.tag.some(
                        (tag) =>
                          accesPermissionParsed?.[tag] &&
                          accesPermissionParsed[tag] !== "0",
                      )
                    : accesPermissionParsed?.[item.tag] &&
                      accesPermissionParsed[item.tag] !== "0");

                const nestedContent =
                  item.content && Array.isArray(item.content)
                    ? processContent(item.content)
                    : [];

                if (isAccessible || nestedContent.length > 0) {
                  return { ...item, content: nestedContent };
                }
                return null;
              })
              .filter(Boolean);

          const processedContent = processContent(element.content || []);

          return processedContent.length > 0
            ? { ...element, content: processedContent }
            : null;
        })
        .filter(Boolean);
    } else {
      // If no permissions, filter out manage-operator-account from the full sidebar
      accesedSidebar = sidebar
        .map((section) => ({
          ...section,
          content: section.content.filter(
            (item) => item.tag !== "manage-operator-account",
          ),
        }))
        .filter((section) => section.content.length > 0);
    }

    setLocalAccessedSidebar(accesedSidebar);
  }, [accessPermission, setLocalAccessedSidebar]);
  const flattenSidebar = (items) =>
    items.reduce((acc, item) => {
      acc.push(item);
      if (item.content) {
        acc.push(...flattenSidebar(item.content));
      }
      return acc;
    }, []);

  const flattenedAccessedSidebar = flattenSidebar(localAccessedSidebar);

  const hasAccess =
    isAuthenticated &&
    flattenedAccessedSidebar.some((item) =>
      location.pathname.includes(item.link),
    );

  return hasAccess ? (
    <AppbarWithSidebar
      element={element}
      appbarTitle={`${
        JSON.parse(localStorage.getItem("user")).company?.toUpperCase() ?? ""
      } OPERATOR PORTAL`}
      sidebarTitle="DASHBOARD"
      logo={`${process.env.PUBLIC_URL}/assets/images/mbox_logo.jpg`}
      items={localAccessedSidebar}
    />
  ) : location.pathname === "/" && !isAuthenticated ? (
    <Navigate to="/" />
  ) : (
    <AppbarWithSidebar
      element={<AccessDeniedPage />}
      appbarTitle={`${
        JSON.parse(localStorage.getItem("user")).company?.toUpperCase() ?? ""
      } OPERATOR PORTAL`}
      sidebarTitle="DASHBOARD"
      logo={`${process.env.PUBLIC_URL}/assets/images/mbox_logo.jpg`}
      items={localAccessedSidebar}
    />
  );
}
